import * as ko from "knockout";
import * as $ from "jquery";
ko.bindingHandlers.visibility = {
    update: function (element, valueAccessor, allBindings, viewModel) {
        var visible = ko.unwrap(valueAccessor());
        if (visible) {
            $(element).css("visibility", "visible");
        }
        else {
            $(element).css("visibility", "hidden");
        }
    }
};